import numeral from 'numeral';

export default number =>
  numeral(number)
    .format('0.[00]%')
    .replace(/-/, '- ');



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/toPercentage.js